export { getPrimaryProductChannel } from './product-channel.util';
